import { writable, type Writable } from 'svelte/store'
import type { Variant2Info } from '../types'

export const createVariant2Info = () => {
    const initialState: Variant2Info | null = null

    const { subscribe, set } = writable<Variant2Info | null>(initialState)

    return {
        subscribe,
        set,
    }
}
